<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('Thanas')" >
            <app-default-button
                    v-if="$can('create_districts')"
                    :title="$t('add_thanas')"
                    @click="openAddModal"
            />
        </app-page-top-section>

        <app-table
                :options="options"
                id="police-table"
                @action="triggerActions"
        />

        <app-confirmation-modal
                v-if="confirmationModalActive"
                icon="trash-2"
                modal-id="app-confirmation-modal"
                @confirmed="confirmed('police-table')"
                @cancelled="cancelled"
        />

        <app-thana-create-edit
                v-if="isModalActive"
                v-model="isModalActive"
                :selected-url="selectedUrl"
        />
    </div>
</template>

<script>
    import HelperMixin from "../../../Mixins/HelperMixin";
    import TriggerActionMixin from "../../../Mixins/TriggerActionMixin";
    import DataTableHelperMixin from "../../../Mixins/DatatableHelperMixin";
    import PoliceStationMixin from "./Mixins/ThanaMixin";
    import {THANAS} from "../../../Config/ApiUrl";
    import {urlGenerator} from "../../../Helpers/AxiosHelper";

    export default {
        name: "PoliceStations",
        mixins: [PoliceStationMixin, HelperMixin, TriggerActionMixin, DataTableHelperMixin],
        data() {
            return {
                selectedUrl: '',
                isModalActive: false,
                confirmationModalActive: false,
                delete_url: ''
            }
        },
        methods: {
            triggerActions(row, action, active) {
                if (action.name === 'edit') {
                    this.selectedUrl = `${THANAS}/${row.id}`;
                    this.isModalActive = true;
                } else {
                    const baseURL = `/${action.url}/${row.id}`;
                    if (action.type === 'page') {
                        window.location = urlGenerator(`${baseURL}/${action.name}`);
                    }

                    if (action.name === 'delete') {
                        this.delete_url = baseURL
                        this.confirmationModalActive = true;
                    }
                }
            },
            openAddModal() {
                this.isModalActive = true;
            }
        },
        watch: {
            isModalActive: function (isModalActive) {
                if (!isModalActive) {
                    this.selectedUrl = '';
                }
            }
        }
    }
</script>

<style scoped>

</style>